import moment from 'moment'
export default {
    methods: {
        taxDue(clazz, taxRate) {
            if (taxRate !== null) {
                return this.roundToThePenny(this.premiumDue(clazz) * taxRate)
            } else {
                return 0
            }
        },
        premiumDue(clazz) {
            let payroll = this.stripNonFloatChars(clazz.payroll)
            if (!payroll || !(/^\d*(\.\d{0,2})?$/.test(payroll)) || payroll === '.') {
                return 0
            } else {
                return this.roundToThePenny((payroll / 100) * clazz.netRate)
            }
        },
        taxTotal(location) {
            let total = location.classCodes.reduce((accumulator, clazz) => {
                return (this.stripNonFloatChars(clazz.payroll)) ? accumulator + this.taxDue(clazz, location.taxRate) : accumulator
            }, 0);
            return this.roundToThePenny(total);
        },
        premiumTotal(location) {
            let total =  location.classCodes.reduce((accumulator, clazz) => {
                return (this.stripNonFloatChars(clazz.payroll)) ? accumulator + this.premiumDue(clazz) : accumulator
            }, 0);
            return this.roundToThePenny(total);
        },
        isMultiplePolicy() {
            return this.policies.length > 1
        },
        isPolicyTransitioningThisMonth(pol, reporting) {
            let effectiveDate = moment(pol.effectiveDate, "YYYY-MM-DD")
            let expirationDate = moment(pol.expirationDate, "YYYY-MM-DD")
            let periodStartDate = moment(reporting.payrollPeriodStart, "YYYY-MM-DD")
            let periodEndDate = moment(reporting.payrollPeriodEnd, "YYYY-MM-DD")
            return ((periodStartDate < effectiveDate) && (effectiveDate < periodEndDate)) ||
                ((periodStartDate < expirationDate) && (expirationDate < periodEndDate));
        },
        lastPolicyAndLocation(i, j, k) {
            return (this.policies.length === (i + 1)
                && this.policies[i].jurisdictions.length === (j + 1)
                && this.policies[i].jurisdictions[j].locations.length === (k + 1)
            );
        },
        stripNonFloatChars(amount){
            return amount && amount.replace(/[^\d.-]/g, '')
        },
        roundToThePenny(inVal){
            return Math.round(inVal * 100)/100;
        },
        dateToDateRange(dateFrom, dateTo, joinString) {
            return dateFrom + " " + joinString + " " + dateTo
        },
        isoDateToUsDateRange(isoDateFrom, isoDateTo, joinString) {
            let dateFrom = moment(isoDateFrom, "YYYY-MM-DD").format("MM/DD/YYYY")
            let dateTo = moment(isoDateTo, "YYYY-MM-DD").format("MM/DD/YYYY")
            return this.dateToDateRange(dateFrom, dateTo, joinString)
        },
        reportingDateToUsDateRange(reporting, joinString) {
            return this.isoDateToUsDateRange(reporting.payrollPeriodStart, reporting.payrollPeriodEnd, joinString)
        }
    }
}